import { VuexModule, Mutation } from "vuex-module-decorators";
import type { PaginationDataState, PaginationInstance } from "@/types";
import { paginationInstanceFactory } from "@/utils/instance";

export default class PaginationModule<S, R>
  extends VuexModule<S, R>
  implements PaginationDataState {
  public paginationData: PaginationInstance = paginationInstanceFactory();

  @Mutation
  savePaginationData(data: PaginationInstance = paginationInstanceFactory()) {
    this.paginationData = data;
  }

  protected get testChildGetter() {
    // console.log('child getter does"t work');
    return 1;
  }
}
